export function samplingReportPageProps() {
  const reports = [
    {
      reportIdentifier: 'sampling_workbook',
      type: 'tableau_workbook',
      workbookTabs: [
        {
          tableauIframeHeight: 1500,
          tableauTabUri: 'Display',
          tableauWorksheetName: 'Display',
          title: 'Display',
          urlFragment: 'display',
        },
        {
          tableauIframeHeight: 1300,
          tableauTabUri: 'Collect',
          tableauWorksheetName: 'Collect',
          title: 'Collect',
          urlFragment: 'collect',
        },
        {
          tableauIframeHeight: 1300,
          tableauTabUri: 'Images',
          tableauWorksheetName: 'Images',
          title: 'Images',
          urlFragment: 'images',
        },
        {
          tableauIframeHeight: 1600,
          tableauTabUri: 'Sentiment',
          tableauWorksheetName: 'Sentiment',
          title: 'Sentiment',
          urlFragment: 'sentiment',
        },
      ],
    },
    {
      reportIdentifier: 'sampling_reviews',
      urlFragment: 'sampling-reviews',
      title: 'Sampling Reviews',
      type: 'columnar',
    },
  ];
  const DEFAULT_TAB = reports[0].workbookTabs[0].urlFragment;
  const PAGE_URL = '/sampling';
  const PAGE_TITLE = 'Sampling';

  const navigationProps = {
    crumbs: [
      {
        label: 'Analytics',
        href: `/`,
      },
      {
        label: PAGE_TITLE,
        href: PAGE_URL,
      },
    ],
    activePrimary: 'Analytics',
    activeSecondary: PAGE_TITLE,
  };

  return {
    defaultTab: DEFAULT_TAB,
    navigationProps,
    pageUrl: PAGE_URL,
    reports,
  };
}
